/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_DateInputs */

const en_settings_payments_date = /** @type {(inputs: Settings_Payments_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const zh_settings_payments_date = /** @type {(inputs: Settings_Payments_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Settings_Payments_DateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_date = /** @type {((inputs?: Settings_Payments_DateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_DateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_date(inputs)
	return zh_settings_payments_date(inputs)
});
export { settings_payments_date as "settings.payments.date" }